app.service('flashMessage', function($global) {

	function globalFlashMessage(message) {

		localStorage.setItem('flashMessageType', 'success');
		localStorage.setItem('flashMessage', message);
	}

	function globalFlashWarningMessage(message) {

		localStorage.setItem('flashMessageType', 'warning');
		localStorage.setItem('flashMessage', message);
	}

	function globalFlashErrorMessage(message) {

		localStorage.setItem('flashMessageType', 'error');
		localStorage.setItem('flashMessage', message);
	}

	function init() {

		var message = localStorage.getItem('flashMessage');
		var messageType = localStorage.getItem('flashMessageType');

		if (!message) {
			return;
		}

		if (messageType === 'success') {

			toastr.success(message);
		}
		else if (messageType === 'warning') {

			toastr.warning(message);
		}
		else if (messageType === 'error') {

			toastr.error(message);
		}

		localStorage.removeItem('flashMessage');
		localStorage.removeItem('flashMessageType');
	}

	$global('flashMessage', globalFlashMessage);
	$global('flashWarningMessage', globalFlashWarningMessage);
	$global('flashErrorMessage', globalFlashErrorMessage);

	return {
		init : init
	}
});